'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';

export function Footer() {
  const t = useTranslations('footer');
  const navT = useTranslations('nav');

  return (
    <footer className="bg-white border-t border-gray-100 py-20 dark:bg-black dark:border-gray-800">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          <div className="space-y-6">
            <Link href="/" className="flex flex-col w-fit">
              <span className="text-2xl font-bold tracking-tight text-black dark:text-white">HVN</span>
              <span className="text-[10px] font-mono tracking-[0.3em] text-gray-500 dark:text-gray-400 -mt-1 uppercase">DEVELOPERS</span>
            </Link>
            <p className="text-sm text-gray-500 max-w-xs leading-relaxed dark:text-gray-400">
              {t('desc')}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-6 text-black dark:text-white">{t('links')}</h4>
            <ul className="space-y-4 text-sm text-gray-500 dark:text-gray-400">
              <li><Link href="/" className="hover:text-black dark:hover:text-white transition-colors">{navT('home')}</Link></li>
              <li><Link href="/projects" className="hover:text-black dark:hover:text-white transition-colors">{navT('projects')}</Link></li>
              <li><Link href="/pricing" className="hover:text-black dark:hover:text-white transition-colors">{navT('pricing')}</Link></li>
              <li><Link href="/#contact" className="hover:text-black dark:hover:text-white transition-colors">{navT('contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-6 text-black dark:text-white">{t('connect')}</h4>
            <ul className="space-y-4 text-sm text-gray-500 dark:text-gray-400">
              <li>hvnkompaniyasi@gmail.com</li>
              <li>+998-33-007-01-50</li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4 dark:border-gray-800">
          <p className="text-[11px] text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
